import './setupResizeObserver'
import React from 'react'
import ReactDOM from 'react-dom'
import './assets/locales/i18n'
import { store } from './redux/store'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import { Spin } from 'antd'
import App from './App'
import AppThemeProvider from './theme/AppThemeProvider'
import NotificationProvider from './providers/NotificationProvider'
import AppLoadingIndicator from '@components/common/loading/AppLoadingIndicator'

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <Provider store={store}>
    <AppThemeProvider>
      <NotificationProvider>
        <Router>
          <App />
        </Router>
      </NotificationProvider>
    </AppThemeProvider>
  </Provider>,
  document.getElementById('root')
)

Spin.setDefaultIndicator(
  <span className="auth-loading-indicator-wrap">
    <AppLoadingIndicator size={56} />
  </span>,
)
